import type { PointerEvent as ReactPointerEvent } from "react";

/**
 * Spawn a small gold ripple at the pointer position inside the target button.
 * Attach via `onPointerDown={addRipple}` on any element that is
 * position: relative + overflow: hidden (e.g. .btn-gold, .btn-gold-outline).
 */
export function addRipple(e: ReactPointerEvent<HTMLElement>) {
  if (typeof window === "undefined") return;
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

  const el = e.currentTarget;
  const rect = el.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const x = e.clientX - rect.left - size / 2;
  const y = e.clientY - rect.top - size / 2;

  const span = document.createElement("span");
  span.className = "btn-ripple";
  span.style.width = `${size}px`;
  span.style.height = `${size}px`;
  span.style.left = `${x}px`;
  span.style.top = `${y}px`;

  el.appendChild(span);
  window.setTimeout(() => span.remove(), 600);
}
